export const SMART_RISK_CONFIG = {
  asset: {
    cashIds: [1, 23, 24, 25],
    creditIds: [22, 26, 27, 28],
  },
};
